import { Undef } from 'types/UtilityTypes';

// Suggestion payloads sometimes send lists as numeric-key objects ({ 0: ..., 1: ... }).
export function asArrayOrObjectValues<T>(
  value: Undef<T[] | Record<string, T>>
): T[] {
  if (Array.isArray(value)) {
    return value;
  }

  if (value) {
    return Object.values(value);
  }

  return [];
}
